var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.toasts},[_c('transition-group',{attrs:{"name":"list"}},_vm._l((_vm.toasts),function(toast){return _c('VToast',{key:toast.id,class:_vm.$style.toast,attrs:{"toast":toast}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }